import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

document.addEventListener('DOMContentLoaded', () => {
  Fancybox.bind('[data-fancybox]', {
    // Your custom options
    Toolbar: {
      display: {
        left: ['infobar'],
        middle: [],
        right: ['close'],
      },
    },
    Hash: false,
    Thumbs: {
      type: 'classic',
    },
    Images: {
      zoom: false,
      // https://v5.fancyapps.com/fancybox/plugins/images/#picture
      content: (_ref, slide) => {
        let rez = '<picture class="photo-gallery__zoomed-image">';

        const sources = slide.sources?.split(';') || [];
        // @ts-ignore
        const types = slide.types?.split(';') || [];
        const media = slide.media?.split(';') || [];

        sources.forEach((srcset, index) => {
          const typeAttr = types[index] ? ` type="${types[index]}"` : '';
          const mediaAttr = media[index] ? ` media="${media[index]}"` : '';
          // Use srcset for Fancybox (not lazy), or data-srcset if you want to keep lazyload
          rez += `<source${typeAttr}${mediaAttr} data-srcset="${srcset.trim()}" />`;
        });

        // Use src for Fancybox (not lazy), or data-src and class="lazyload" if you want lazy
        rez += `<img data-src="${slide.src}" alt="" class="lazyload" />`;
        rez += '</picture>';

        return rez;
      },
    },
  });
});
